import { Controller } from "@hotwired/stimulus"

// Submits its form a moment after the visitor is looking at the page, unless they act first.
// The clock runs only while the page is visible; the first key, pointer or focus stops it for good.
// It submits only once: then it's "submitted", and coming back to the tab doesn't arm it again.
// The state value ("armed", then "submitted" or "cancelled") is what the markup styles itself by.
export default class extends Controller {
  static values = { delay: Number, state: { type: String, default: "idle" } }

  // Arming schedules the submit, through stateValueChanged; a page that comes back already armed was scheduled as its
  // value loaded.
  connect() {
    if (this.stateValue === "idle") this.stateValue = "armed"
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  schedule() {
    clearTimeout(this.timeout)
    if (this.stateValue !== "armed" || document.visibilityState !== "visible") return

    this.timeout = setTimeout(() => this.submit(), this.delayValue)
  }

  cancel() {
    this.stateValue = "cancelled"
  }

  stateValueChanged() {
    this.schedule()
  }

  submit() {
    this.stateValue = "submitted"
    this.element.requestSubmit()
  }
}
